import { useQuery } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';
import { useFeatureFlags } from '../../../contexts/FeatureFlagsContext';
import { ConsolidateAssetsModal as ConsolidateAssetsModalLegacy } from './custom';
import { ConsolidateAssetsModal as ConsolidateAssetsModalCLM } from './customCLM';
import { GLOBAL_ASSUMPTIONS_QUERY } from './operations';

export const ConsolidateAssetsButton = ({
  discountRate,
  open,
  setDiscountRate,
  setOpen,
  onRequestReport,
}) => {
  const [baseYear, setBaseYear] = useState(new Date().getFullYear());
  const [basePricesGlobalAssumptions, setBasePricesGlobalAssumptions] = useState({
    oil: ['', '', '', '', ''],
    escalatorOil: '',
    gas: ['', '', '', '', ''],
    escalatorGas: '',
  });

  const { data: globalAssumptionsData } = useQuery(GLOBAL_ASSUMPTIONS_QUERY);

  const calculateBasePrices = useCallback((base, year1, year2, year3, year4, escalation) => {
    const factor = 1 + escalation / 100;
    const prices = [base, year1, year2, year3, year4].map(price => {
      return price !== '' ? parseFloat(price) : '';
    });

    for (let i = 1; i < prices.length; i++) {
      if (prices[i] === '') {
        prices[i] = prices[i - 1] !== '' ? prices[i - 1] * factor : '';
      }
    }

    return prices.map(price => String(price));
  }, []);

  useEffect(() => {
    if (globalAssumptionsData?.globalAssumptions?.baseYear) {
      const baseYear = parseFloat(globalAssumptionsData.globalAssumptions.baseYear);
      const brentPriceBaseYear = parseFloat(
        globalAssumptionsData.globalAssumptions.brentPriceBaseYear,
      );
      const brentPriceBaseYearPlusOne = parseFloat(
        globalAssumptionsData.globalAssumptions.brentPriceBaseYearPlusOne,
      );
      const brentPriceBaseYearPlusTwo = parseFloat(
        globalAssumptionsData.globalAssumptions.brentPriceBaseYearPlusTwo,
      );
      const costInflation = parseFloat(globalAssumptionsData.globalAssumptions.costInflation);
      const oilPrices = calculateBasePrices(
        brentPriceBaseYear,
        brentPriceBaseYearPlusOne,
        brentPriceBaseYearPlusTwo,
        '',
        '',
        costInflation,
      );

      const basePrices = {
        oil: oilPrices,
        escalatorOil: costInflation,
        gas: ['', '', '', '', ''],
        escalatorGas: '',
      };

      setBaseYear(baseYear);
      setBasePricesGlobalAssumptions(basePrices);
    }
  }, [globalAssumptionsData, calculateBasePrices]);

  const { enableConsolidatedLiveModels } = useFeatureFlags();
  const ConsolidateAssetsModal = enableConsolidatedLiveModels
    ? ConsolidateAssetsModalCLM
    : ConsolidateAssetsModalLegacy;

  return (
    <ConsolidateAssetsModal
      open={open}
      setOpen={setOpen}
      discountRate={discountRate}
      onRequestReport={onRequestReport}
      setDiscountRate={setDiscountRate}
      baseYear={baseYear}
      basePricesGlobalAssumptions={basePricesGlobalAssumptions}
      calculateBasePrices={calculateBasePrices}
    />
  );
};
